<script>
export default {
  methods:{
    query(numOfShifts=10) {
      const query = {}
      query.limit = numOfShifts;
      query.include = [
        {model: 'shiftsMediaTypes'},
        {model: 'shiftsMediaTypesCount'},
        {model: 'shiftsJson'},
        
      ]
      query.attributes = ["RowID","StartDateTime","EndDateTime","IDUsed","NetSalesTaxed","NetSalesNonTaxed"]//,"NetSalesTaxExempt","Tax1","Tax2","Tax3","TaxOther","TotalNumTrans","Open_Cashier_ID","Close_Cashier_ID","Close_Out_Index","CashbackAmount","Tax4","Tax5","Tax6"]
      // query.where = {StartDateTime : {"$gte": '2020-01-01'}, StartDateTime : {"$lt": '2020-01-02'}} 
      query.where = {
        $and:[
          // A one day buffer before and after is added
          // so that you can get all the shifts that start just before midnight
          // the excess shifts are filtered in the ShiftStore
          {StartDateTime : {"$gte": moment(this.timestamps.from).add('day', -1).format('YYYY-MM-DD HH:mm:ss')}}, 
          {StartDateTime : {"$lt": moment(this.timestamps.to).add('day', 1).format('YYYY-MM-DD HH:mm:ss')}}, 
          // {StartDateTime : {"$gte": this.timestamps.from}},
          // {StartDateTime : {"$lt": this.timestamps.to}},
          // {StartDateTime : {"$lt": moment(this.day).add(1, 'day').format('YYYY-MM-DD')}},
        ]
      } 
      query.order = [['StartDateTime', 'ASC'],]
      return query
    },
  },
}
</script>